import { render, staticRenderFns } from "./ViewCompanyData.vue?vue&type=template&id=45239486&"
import script from "./ViewCompanyData.vue?vue&type=script&lang=js&"
export * from "./ViewCompanyData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports